module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-regular-400-fa5f132deb163050a1484c5373b21fe3.svg";